export default __webpack_public_path__ + "static/media/Groupe 81.85678505.svg";